<div>
    <span>
        This page is not supported in mobile devices, please use a device with larger screen to view
        this page.
    </span>
</div>
